import { apiGet, apiPatch, apiPost, planningPath } from './PlanningApiClient';

/**
 * Real, server-persisted notifications — currently just @mentions in
 * comments (see ans-backend's notifyMentions). Separate from
 * NotificationProvider's local/ephemeral toast notifications, which never
 * touch the server; the provider merges both into one list for display.
 */
export interface ServerNotification {
  id: string;
  message: string;
  entity_type: string | null;
  entity_id: string | null;
  read: boolean;
  created_at: string;
}

interface ApiNotification {
  id: string;
  message: string;
  entity_type: string | null;
  entity_id: string | null;
  read: boolean;
  created_at: string;
}

function transform(n: ApiNotification): ServerNotification {
  return {
    id: String(n.id),
    message: n.message,
    entity_type: n.entity_type,
    entity_id: n.entity_id,
    read: n.read,
    created_at: n.created_at,
  };
}

export async function loadServerNotifications(): Promise<{ notifications: ServerNotification[]; unreadCount: number }> {
  const res = await apiGet<{ notifications: ApiNotification[]; unread_count: number }>(planningPath('/notifications'));
  return {
    notifications: (res?.notifications ?? []).map(transform),
    unreadCount: res?.unread_count ?? 0,
  };
}

export async function markServerNotificationRead(id: string): Promise<void> {
  await apiPatch(planningPath(`/notifications/${id}/read`), {});
}

export async function markAllServerNotificationsRead(): Promise<void> {
  await apiPost(planningPath('/notifications/mark-all-read'), {});
}
